































































































































































































import { defineComponent, toRefs, PropType, computed, ref, onMounted } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  DeepBidType,
  BidStrategyType,
  AdgroupConfig,
  SmartBidType,
  AdgroupListItem,
  CreateMode,
} from '@tt4b/ttam-enums';
import { trackEvent } from './../../../utils/index';
import BidStrategy from './index';
import { cloneDeep } from 'lodash-es';
import { useAdgroupBidTypes, useStore, StateEnum, useAdgroupBiddingValidate } from '@tt4b/ttam-hooks';
import TargetCpa from './target-cpa/index.vue';
import TargetRoas from './target-roas/index.vue';
import { useUnifiedBidStrategyVisible } from './hooks/unified-bid-strategy';

const name = 'ttam-bid-strategy-compose';
export default defineComponent({
  name,
  components: {
    TargetCpa,
    TargetRoas,
    TtamBidStrategyLabel: BidStrategy.TtamBidStrategyLabel,
    TtamBidStrategyTooltip: BidStrategy.TtamBidStrategyTooltip,

    TtamBidStrategySuggestBid: BidStrategy.TtamBidStrategySuggestBid,
    TtamBidStrategyDcTips: BidStrategy.TtamBidStrategyDcTips,
    TtamBidStrategyDcInfo: BidStrategy.TtamBidStrategyDcInfo,

    TtamBidStrategyVideoViewTips: BidStrategy.TtamBidStrategyVideoViewTips,
    TtamBidStrategyRadios: BidStrategy.TtamBidStrategyRadios,

    TtamBidStrategyRoasCheckbox: BidStrategy.TtamBidStrategyRoasCheckbox,
    TtamBidStrategyRoasTips: BidStrategy.TtamBidStrategyRoasTips,
    TtamBidStrategySet: BidStrategy.TtamBidStrategySet,

    TtamBidStrategyDeepBidCheckbox: BidStrategy.TtamBidStrategyDeepBidCheckbox,
    TtamBidStrategyDeepBidSet: BidStrategy.TtamBidStrategyDeepBidSet,
    TtamBidStrategyDeepBidSecondRateReminder: BidStrategy.TtamBidStrategyDeepBidSecondRateReminder,

    TtamBidStrategyLearningPhaseTips: BidStrategy.TtamBidStrategyLearningPhaseTips,
    TtamBidStrategyOptgoalInappeventTitle: BidStrategy.TtamBidStrategyOptgoalInappeventTitle,
    TtamBidStrategyOptgoalInstallWithInappeventTitle: BidStrategy.TtamBidStrategyOptgoalInstallWithInappeventTitle,
    TtamBidCapToCostCapTips: BidStrategy.TtamBidCapToCostCapTips,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    originAdgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
      required: true,
    },
    dcAdgroupList: {
      type: Array as PropType<AdgroupListItem[]>,
      required: true,
      default: () => [],
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: () => CreateMode.CREATE,
    },
    hasLowestCost: {
      type: Boolean,
      default: false,
    },
    isLearningPhase: {
      type: Boolean,
      default: false,
    },
    /** 是否在 split test 控制组 */
    isControlGroup: {
      type: Boolean,
      default: false,
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup(props, { emit }) {
    const {
      adgroupData,
      originAdgroupData,
      campaignData,
      adgroupConfig,
      isLearningPhase,
      hasLowestCost,
      dcAdgroupList,
      createMode,
      isControlGroup,
    } = toRefs(props);

    const isDcEditClicked = ref(false);

    /** Get Data From Store  */
    const { state } = useStore();
    const areaData = computed(() => state[StateEnum.areaData].data.value);
    const voStatus = computed(() => state[StateEnum.voStatus].data.value);
    const appEvents = computed(() => state[StateEnum.appEvents].data.value);

    const isShouldHiddenOptions = ref(false);

    const _bidSetCheckBoxSelected = computed({
      get: () => adgroupData.value?.roasStatus,
      set: val => {
        emit('roas-status-change', val);
      },
    });

    const _multiBidChecked = computed({
      get: () => adgroupData.value?.deepBidType === DeepBidType.MULTI_BID,
      set: val => {
        emit('deep-bid-type-change', val ? DeepBidType.MULTI_BID : DeepBidType.AUTO_BID);
      },
    });

    /** BidcapSuggestBid  */
    const { data: bidcapSuggestBidData, run: bidcapSuggestBidRun } = BidStrategy.useBidcapSuggestBidDataSource({
      adgroupData,
      campaignData,
    });

    const onBidcapSuggestBidApply = () => {
      emit('bid-change', {
        bid: bidcapSuggestBidData.value?.suggestBidNum,
      });
    };

    const { visible: bidcapSuggestBidVisible } = BidStrategy.useBidcapSuggestBidPropsVisible({
      campaignData,
      adgroupConfig,
      bidcapSuggestBidData,
    });

    /** VideoViewTips  */
    const { visible: videoViewTipsVisible } = BidStrategy.useVideoViewTipsPropsVisible({
      adgroupData,
    });

    /** LearningPhaseTips  */
    const { visible: learningPhaseTipsVisible } = BidStrategy.useLearningPhaseTipsPropsVisible({
      adgroupConfig,
      isLearningPhase,
    });

    /** Bid cap upgrade to Cost cap */
    const { isBidCapToCostCapEnable, isEdit } = BidStrategy.useBidCapToCostCapEnable({
      campaignData,
      originAdgroupData,
      createMode,
    });
    const { isBidCapToCostCapTipVisible } = BidStrategy.useBidCapToCostCapTipVisible({
      adgroupData,
      isBidCapToCostCapEnable,
      isControlGroup,
    });

    /** Radio  */
    const { allOptions: allStrategyList, options: strategyList } = BidStrategy.useRadiosPropsOptions({
      adgroupData,
      campaignData,
      voStatus,
      appEvents,
      dcAdgroupList,
      createMode,
      isBidCapToCostCapTip: isBidCapToCostCapTipVisible,
    });

    const { isHighestValue } = useAdgroupBidTypes({
      adgroupFormData: adgroupData,
      strategyList,
    });

    const _smartBidStrategy = computed({
      get: () => adgroupData.value?.smartBidType,
      set: val => {
        if (adgroupData.value.smartBidType === val) {
          return;
        }

        emit('smart-bid-type-change', val);

        // 非HighestValue时去掉roas的复选框勾选
        if (!isHighestValue.value && _bidSetCheckBoxSelected.value) {
          _bidSetCheckBoxSelected.value = false;
        }
      },
    });

    const strategyListForDisplay = computed(() => {
      if (isShouldHiddenOptions.value) {
        return [strategyList.value.find(item => item.value === _smartBidStrategy.value) ?? ({} as any)];
      }

      if (bidcapSuggestBidData.value?.isInBidcapSuggestBidTest) {
        return cloneDeep(strategyList.value).sort(item => (item.type === BidStrategyType.BID_CAP ? -1 : 0));
      }

      return strategyList.value;
    });

    const { isUnifiedCpaBidStrategyVisible, isUnifiedRoasBidStrategyVisible } = useUnifiedBidStrategyVisible({
      strategyList,
      campaignData,
    });

    const { disabled: radioDisabled } = BidStrategy.useRadiosPropsDisabled({
      adgroupConfig,
    });

    /** Set */
    const setDataKey = computed(
      () => strategyListForDisplay.value?.find(o => o.value === _smartBidStrategy.value)?.dataKey,
    );
    const _bid = computed({
      get: () => (adgroupData.value?.[setDataKey.value] === 0 ? '' : adgroupData.value?.[setDataKey.value]),
      set: val => {
        if (val === adgroupData.value?.[setDataKey.value]) {
          return;
        }
        emit('bid-change', {
          [setDataKey.value]: val || 0,
        });
      },
    });

    const toolTipsDisabled = ref(false);

    const { currencyUnit } = BidStrategy.useCommonPropsCurrencyUnit({
      adgroupData,
      campaignData,
      strategyList,
      appEvents,
    });

    const { visible: setVisible } = BidStrategy.useSetPropsVisible({
      adgroupData,
      campaignData,
      voStatus,
    });

    const hangleToolTipsDisable = val => {
      toolTipsDisabled.value = val;
    };

    /** RoasCheckbox  */
    const { visible: roasCheckboxVisible } = BidStrategy.useRoasCheckboxPropsVisible();
    const {
      disabled: roasCheckboxDisabled,
      isVOMinRoasVisble,
      isVOHighestValueVisible,
    } = BidStrategy.useRoasCheckboxPropsDisabled({
      adgroupData,
      adgroupConfig,
      campaignData,
      voStatus,
    });

    /**  RoasTips */
    const { visible: roasTipsVisible } = BidStrategy.useRoasTipsPropsVisible({
      adgroupData,
      campaignData,
      strategyList,
    });
    const { tips: roasTips } = BidStrategy.useRoasTipsPropsTips({
      adgroupData,
    });

    /**  OptgoalInappeventTitle */
    const { visible: optgoalInappeventTitleVisible } = BidStrategy.useOptgoalInappeventTitlePropsVisible({
      adgroupData,
      campaignData,
    });

    /**  OptgoalInstallWithInappeventTitle */
    const { visible: optgoalInstallWithInappeventTitleVisible } =
      BidStrategy.useOptgoalInstallWithInappeventTitlePropsVisible({
        adgroupData,
        campaignData,
        appEvents,
      });
    const { tips: optgoalInstallWithInappeventTitleTips } = BidStrategy.useOptgoalInstallWithInappeventTitlePropsTips({
      adgroupData,
      campaignData,
      appEvents,
    });

    /** DeepBid  */
    const { visible: deepBidVisible } = BidStrategy.useDeepBidPropsVisible({
      adgroupData,
      campaignData,
      appEvents,
    });

    const { disabled: deepBidCheckboxDisabled } = BidStrategy.useDeepBidCheckboxPropsDisabled({
      adgroupConfig,
    });

    const { title: deepBidCheckboxTitle } = BidStrategy.useDeepBidCheckboxPropsTitle({
      adgroupData,
      campaignData,
      appEvents,
    });

    const { tips: deepBidCheckboxTips } = BidStrategy.useDeepBidCheckboxPropsTips({
      adgroupData,
      campaignData,
      appEvents,
    });

    const { title: deepBidSecondRateReminderTitle } = BidStrategy.useDeepBidSecondRateReminderPropsTitle({
      adgroupData,
      campaignData,
      appEvents,
    });

    const { tips: deepBidSecondRateReminderTips } = BidStrategy.useDeepBidSecondRateReminderPropsTips({
      adgroupData,
      campaignData,
      appEvents,
    });

    const { dataKey } = BidStrategy.useDeepBidSetPropsDatakey({
      adgroupData,
      campaignData,
      appEvents,
    });

    const _deepBid = computed({
      get: () => (adgroupData.value[dataKey.value] === 0 ? '' : adgroupData.value?.[dataKey.value]),
      set: val => {
        if (val === adgroupData.value?.[dataKey.value]) {
          return;
        }

        emit('deep-bid-change', { [dataKey.value]: val || 0 });
      },
    });

    const { inputType: deepBidSetInputType } = BidStrategy.useDeepBidSetPropsInputType({
      adgroupData,
      campaignData,
      appEvents,
    });

    const { currencyUnit: deepBidSetCurrencyUnit } = BidStrategy.useDeepBidSetPropsCurrencyUnit({
      adgroupData,
      campaignData,
      appEvents,
    });

    /** StrategyTooltip  */
    const { visible: strategyTooltipVisible } = BidStrategy.useStrategyTooltipPropsVisible({
      adgroupData,
      campaignData,
    });

    const { strategyType: strategyTooltipStrategyType } = BidStrategy.useStrategyTooltipPropsStrategyType(campaignData);

    const { disabled: strategyTooltipDisabled } = BidStrategy.useStrategyTooltipPropsDisabled({
      toolTipsDisabled,
    });

    /** DcInfo  */
    const { visible: dcInfoVisible } = BidStrategy.useDcInfoPropsVisible({
      adgroupData,
      campaignData,
      adgroupConfig,
      dcAdgroupList,
      strategyList,
      isDcEditClicked,
      hasLowestCost,
    });

    const { visible: dcInfoEditButtonVisible } = BidStrategy.useDcInfoPropsEditButtonVisible({
      adgroupData,
      adgroupConfig,
      strategyList,
    });

    const onDcInfoEditButtonClick = () => {
      isDcEditClicked.value = true;
    };

    /** DcTips  */
    const { visible: dcTipsVisible } = BidStrategy.useDcTipsPropsVisible({
      adgroupData,
      campaignData,
      adgroupConfig,
      dcAdgroupList,
      strategyList,
      isDcEditClicked,
      hasLowestCost,
      createMode,
    });

    /** Common  */
    const { learnMore } = BidStrategy.useCommonPropsLearnMore({
      adgroupData,
      campaignData,
    });
    const { currencyOption } = BidStrategy.useCommonPropsCurrencyOption();
    const onDcTipsLinkClick = () => {
      trackEvent('create_adg_bid_edit_switch_now');
      _smartBidStrategy.value = SmartBidType.NO_BID;
    };

    const currentCurrencyOption = computed(() =>
      // MinimumRoas roas 固定精度为 2
      isHighestValue.value && _bidSetCheckBoxSelected.value
        ? { ...currencyOption.value, precision: 2 }
        : currencyOption.value,
    );

    /** SuggestBid  */
    const curStrategyItem = computed(() => strategyList.value?.find(o => o.value === _smartBidStrategy.value));
    const {
      data: suggestBidData,
      run: suggestBidRun,
      isLoading: suggestBidIsLoading,
      error: suggestBidIsError,
    } = BidStrategy.useSuggestBidDataSource({
      adgroupData,
      adgroupConfig,
      campaignData,
      areaMap: computed(() => areaData.value?.areaMap),
      curStrategyItem,
      createMode,
    });
    const onSuggestBidApply = (val: string) => {
      _bid.value = val;
    };

    const onSuggestBidRefresh = () => {
      suggestBidRun();
    };

    onMounted(async () => {
      if (dcInfoVisible.value && !adgroupConfig.value?.disableIsDcEditClicked) {
        _smartBidStrategy.value = SmartBidType.NO_BID;
      }
      await bidcapSuggestBidRun();
      if (bidcapSuggestBidData.value?.isInBidcapSuggestBidTest && adgroupConfig.value.bidcapSuggestAutoSet) {
        isShouldHiddenOptions.value = true;

        _smartBidStrategy.value = SmartBidType.STANDARD;
      }

      await suggestBidRun();
    });

    /** Validator  */
    const {
      biddingBidValidator,
      biddingBidRequiredValidator,
      biddingBidOptionalValidator,
      roasBidValidator,
      roasBidOptionalValidator,
    } = useAdgroupBiddingValidate({
      campaignFormData: campaignData,
      bidUnit: currencyUnit,
    });
    const bidValidator = bidType => {
      if (bidType === SmartBidType.STANDARD) {
        return biddingBidValidator.value;
      }

      if (bidType === SmartBidType.NO_BID && _bidSetCheckBoxSelected.value) {
        return roasBidValidator.value;
      }

      return [];
    };

    const handleStrategyInputChange = (data: {
      bid?: number;
      capBid?: number;
      roasBid?: number;
      deepBidType?: DeepBidType;
    }) => {
      emit('bid-change', data);
    };
    const bidStrategyFormRef = ref();
    const bidValidateStatus = computed(() =>
      bidStrategyFormRef.value?.validateState === 'error' ? 'danger' : 'default',
    );
    const handleBidStrategyBlur = () => {
      bidStrategyFormRef.value?.onFieldBlur();
    };
    const deepBidStrategyFormRef = ref();
    const deepBidValidateStatus = computed(() =>
      deepBidStrategyFormRef.value?.validateState === 'error' ? 'danger' : 'default',
    );
    const handleDeepBidStrategyBlur = () => {
      deepBidStrategyFormRef.value?.onFieldBlur();
    };

    return {
      name,
      currencyUnit,
      isEdit,

      videoViewTipsVisible,
      learningPhaseTipsVisible,

      onDcTipsLinkClick,
      onDcInfoEditButtonClick,
      learnMore,
      currencyOption,
      currentCurrencyOption,

      strategyList,
      allStrategyList,
      strategyListForDisplay,
      radioDisabled,
      _smartBidStrategy,

      roasCheckboxVisible,
      roasCheckboxDisabled,
      _bidSetCheckBoxSelected,

      roasTipsVisible,
      roasTips,
      isHighestValue,

      optgoalInappeventTitleVisible,

      optgoalInstallWithInappeventTitleVisible,
      optgoalInstallWithInappeventTitleTips,

      isBidCapToCostCapTipVisible,

      deepBidVisible,
      _multiBidChecked,
      deepBidCheckboxDisabled,
      deepBidCheckboxTitle,
      deepBidCheckboxTips,
      deepBidSecondRateReminderTitle,
      deepBidSecondRateReminderTips,
      _deepBid,
      dataKey,
      deepBidSetInputType,
      deepBidSetCurrencyUnit,

      setVisible,
      _bid,

      strategyTooltipVisible,
      strategyTooltipStrategyType,
      strategyTooltipDisabled,

      hangleToolTipsDisable,
      BidStrategyType,

      dcInfoVisible,
      dcInfoEditButtonVisible,
      dcTipsVisible,

      isShouldHiddenOptions,

      onBidcapSuggestBidApply,
      bidcapSuggestBidVisible,
      bidcapSuggestBidData,

      onSuggestBidApply,
      onSuggestBidRefresh,
      suggestBidData,
      suggestBidIsError,
      suggestBidIsLoading,
      isUnifiedCpaBidStrategyVisible,
      isUnifiedRoasBidStrategyVisible,
      isVOHighestValueVisible,
      isVOMinRoasVisble,

      bidValidator,
      handleStrategyInputChange,
      biddingBidRequiredValidator,
      biddingBidOptionalValidator,
      roasBidValidator,
      roasBidOptionalValidator,
      bidStrategyFormRef,
      bidValidateStatus,
      handleBidStrategyBlur,
      deepBidStrategyFormRef,
      handleDeepBidStrategyBlur,
      deepBidValidateStatus,
    };
  },
});
